import { useDispatch, useSelector } from 'react-redux'
import BSToast from 'react-bootstrap/Toast'
import { hide } from '../store/toasts'
import styles from '../styles/Toasts.module.scss'
import useDarkMode from 'use-dark-mode'

// TODO:
// After upgrading to react-bootstrap 5, use the dark mode stuff there,
// then delete styles.override

export default function Toasts() {
  const toasts = useSelector((state) => state.toasts.toasts)
  const dispatch = useDispatch()
  const darkMode = useDarkMode(false)

  return (
    <div className={styles.container}>
      {toasts.map((toast) => {
        return (
          <div
            bg={darkMode.value ? 'dark' : 'light'}
            className='mt-2'
            key={toast.key}
            onClick={() => dispatch(toast.setShow(false))}
          >
            <BSToast
              autohide
              className={darkMode.value && 'text-white'}
              delay={3000}
              onClose={() => dispatch(hide(toast.key))}
              show={toast.show}
            >
              <BSToast.Body className={styles.override}>
                {toast.text}
              </BSToast.Body>
            </BSToast>
          </div>
        )
      })}
    </div>
  )
}
